import React from "react";
import Navbar from "../../Navbar/Navbar";
import MobileNavbar from "../../MobileNavbar/MobileNavbar";
import styles from "./hero.module.scss";
import { Link } from "react-router-dom";
// import { FaAngleRight } from "react-icons/fa";
// import { GrLinkNext } from "react-icons/gr";
import { GrFormNextLink } from "react-icons/gr";
// import img from '../../../assets/new-banners/home_banner.png';
// import { MdOutlineProductionQuantityLimits } from "react-icons/md";
// import { IoPowerSharp } from "react-icons/io5";
import { BsPlayCircleFill } from "react-icons/bs";




const Hero = () => {
  return (
    <section className={styles.hero_mainContainer}>
      {/* <img src={img} alt="banner" className={styles.banner} /> */}
      <Navbar />
      <MobileNavbar />

      <div className={styles.hero_container}>
        <div className={styles.hero_content_container}>
          <div>
            <h1 className={styles.hero_heading}>DIGITAL HEALTHCARE</h1>
            <h1 className={styles.hero_heading}>ECOSYSTEM</h1>
            {/* <button className={styles["product___btn"]} > */}
            <button className={styles["glow-on"]} >
              <Link to={'/landing'} className={styles["glow-on-link"]} >Get Started<BsPlayCircleFill /></Link>
            </button>
          </div>

          <div className={styles.links_container}>
            <Link to='/products' className={styles.links_container__link}>
                All Products <GrFormNextLink className={styles.__rightarrow} />
            </Link>

            <Link to='/products/products_healthcare' className={styles.links_container__link}>
            Health Care Products
              <GrFormNextLink className={styles.__rightarrow} />
            </Link>

            <Link to='/products/products_commercial' className={styles.links_container__link}>
            Commercial Products
              <GrFormNextLink className={styles.__rightarrow} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
